import * as yup from "yup";

export const validator = yup.object().shape({});
